<!--
 * @Descripttion: 
 * @version: 
 * @Author: guoye
 * @Date: 2024-02-10 17:52:15
 * @LastEditors: guoye
 * @LastEditTime: 2024-03-18 10:10:43
-->
<!-- g-toast -->
<script setup>
const props = defineProps({
  // 是否留出顶部安全距离（状态栏高度
  safeAreaInsetTop: {
    type: Boolean,
    default: false,
  },
  //   显示的文本
  message: {
    type: String,
    default: '',
  },
  //   到顶部的距离
  top: {
    type: [String, Number],
    default: 0,
  },
  //   字体颜色
  color: {
    type: String,
    default: '#ffffff',
  },
  //   主题类型
  type: {
    type: String,
    //   primary，success，warning，error
    default: 'default',
  },
  //   跳转的参数
  params: {
    type: Object,
    default: () => {},
  },
  //   背景颜色
  bgColor: {
    type: String,
    default: '',
  },
  //   展示时长，为0时不消失，单位ms
  duration: {
    type: [String, Number],
    default: 3000,
  },
  // 字体大小，单位rpx
  fontSize: {
    type: [String, Number],
    default: 15,
  },
})

const show = ref(false),
  uToast = ref()

const notifyRef = ref()

function showToast(params) {
  nextTick(() => {
    //  console.log(66, 'notifyRef.value-->', notifyRef.value)
    notifyRef.value.show({ ...params })
    //  notifyRef.value.show({
    //    ...params,
    //    ...style[params.type],
    //    title: params.text,
    //    complete() {
    //      params.url &&
    //        uni.navigateTo({
    //          url: params.url
    //        })
    //    }
    //  })
  })
}

watchEffect(() => {
  if (props.message) {
    //  console.log(25, 'props-->', props)
    showToast(props)
  }
})
</script>

<template>
  <!-- <view class="g-toast"> -->
  <u-notify ref="notifyRef"></u-notify>
  <!-- </view> -->
</template>

<style lang="scss"></style>
